// rootReducer.js
import { combineReducers } from "redux";
import dataReducer from "./dataReducers"; // Adjust the path as needed

const rootReducer = combineReducers({
  data: dataReducer, // Assuming dataReducer handles dropdownData
  // If client data is handled by the same reducer
});

export default rootReducer;
